/*
  Simple serial sync/async chriso/validator.js validation wrapper with promises.
*/
import Promise from "bluebird";
import validator from "validator";
import immutable from "immutable";

export class ValidationErrors extends Error {
  constructor(errors) {
    super();
    this.errors = errors;
  }
}

export function isFieldWrong(errors, prop, errorClassName) {
  if (errorClassName === undefined) {
    errorClassName = "error";
  }

  if (errors && errors.get(prop) && errors.get(prop).length > 0) {
    return errorClassName;
  }
  return "";
}

export function isFormValid(form) {
  let keys = Object.keys(form.errors.toJS());

  for (let j = 0; j < keys.length; j++) {
    if (
      form.errors.get(keys[j]) &&
        form.errors.get(keys[j]).length > 0 &&
        keys[j] != "all"
    ) {
      return false;
    }
  }
  return true;
}

export function oneError(msg, prop, showError, obj, ignoreInFormValidation) {
  if (obj === undefined) {
    obj = {};
  }
  if (obj[prop] === undefined) {
    obj[prop] = [];
  }
  obj[prop].push({
    msg: msg,
    prop: prop,
    showError: showError || true,
    ignoreInFormValidation: ignoreInFormValidation || false
  });
  return obj;
}

export default class Validation {
  constructor(object, oneField) {
    this._object = object;
    this._prop = null;
    this._field = null;
    this._oneField = oneField || false;
    this._validator = validator;
    this.errors = {};
    this.isError = false;
    this.promise = Promise.resolve();
  }

  custom(callback, { required } = {}, pass = false) {
    const prop = this._prop;
    const field = this._field;
    const oneField = this._oneField;
    const value = this._object[prop];
    const object = this._object;
    this.promise = this.promise.then(() => {
      if (
        required && !this._isEmptyString(value) ||
          object[prop] === undefined && !pass
      )
        return;
      callback(value, prop, field, object);
    });
    return this;
  }

  _isEmptyString(value) {
    return !this._validator.toString(value).trim();
  }

  prop(prop, field) {
    this._prop = prop;
    this._field = field;
    return this;
  }

  getErrors() {
    return this.custom(
      (value, prop, field, object) => {
        if (this.isError) {
          throw new ValidationErrors(this.errors, "errors");
        }
      },
      {},
      true
    );
  }

  addToErrors(error, prop) {
    if (this.errors[prop] === undefined) {
      this.errors[prop] = [];
    }
    let err = this.errors[prop];
    if (err.length === 1 && err[0].type == "required") {
      return;
    }
    this.isError = true;
    this.errors[prop].push(error);
  }

  required() {
    return this.custom(
      (value, prop, field, object) => {
        const msg = this.getRequiredMessage(prop, value, field);
        this.addToErrors(
          {
            msg: msg,
            prop: prop,
            type: "required",
            showError: true
          },
          prop
        );
      },
      {
        required: true
      }
    );
  }

  email() {
    return this.custom((value, prop, field, object) => {
      if (this._validator.isEmail(value)) return;
      this.addToErrors(
        {
          msg: this.getEmailMessage(prop, value, field),
          prop: prop,
          type: "email",
          showError: true
        },
        prop
      );
    });
  }

  simplePassword() {
    return this.custom((value, prop, field, object) => {
      const minLength = 5;
      if (value.length >= minLength) return;
      this.addToErrors(
        {
          msg: this.getSimplePasswordMessage(minLength),
          prop: prop,
          type: "simplePassword",
          showError: true
        },
        prop
      );
    });
  }

  range(from, to) {
    return this.custom((value, prop, field, object) => {
      if (value.length == 0) return;
      if (value.length >= from && value.length <= to) return;
      this.addToErrors(
        {
          msg: this.getRangeMessage(prop, value, field, from, to),
          prop: prop,
          type: "range",
          showError: true
        },
        prop
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/lib/validationAllFields.js